/* eslint-disable react/no-danger */
import React from 'react';
import { Container } from '@edx/paragon';
import PropTypes from 'prop-types';
import { removeHtmlTags } from '@utils/formatting';

import MainFAQ from './components/MainFAQ';
import MoreInfo from './components/MoreInfo';
import OfacText from './components/OfacText';

const isEmptyHtml = str => (removeHtmlTags(str).trim() === '');

function FAQ({
  faq,
  additionalInformation,
  hasOfacRestrictions,
  commonMessages,
  refProp,
  mobile,
}) {
  const hasFAQ = faq && !isEmptyHtml(faq);
  const hasMoreInfo = additionalInformation && !isEmptyHtml(additionalInformation);

  return (
    <Container size="sm" className={`${mobile ? 'mt-3' : ''}`}>
      {hasFAQ
        && (
          <MainFAQ
            faq={faq}
            commonMessages={commonMessages}
            refProp={refProp}
            mobile={mobile}
          />
        )}

      {hasMoreInfo
      && (
        <MoreInfo
          additionalInformation={additionalInformation}
          commonMessages={commonMessages}
          mobile={mobile}
        />
      )}

      {hasOfacRestrictions
        && (
          <OfacText
            mobile={mobile}
          />
        )}
    </Container>
  );
}

FAQ.propTypes = {
  faq: PropTypes.string,
  additionalInformation: PropTypes.string,
  hasOfacRestrictions: PropTypes.bool,
  commonMessages: PropTypes.shape({
    showMore: PropTypes.shape({}).isRequired,
    showLess: PropTypes.shape({}).isRequired,
  }).isRequired,
  refProp: PropTypes.shape().isRequired,
  mobile: PropTypes.bool,
};

FAQ.defaultProps = {
  faq: null,
  additionalInformation: null,
  hasOfacRestrictions: false,
  mobile: false,
};

export default FAQ;
